/**
 * Entities actions
 */

import * as t from './actionTypes';

/**
 * Chart data requested triggered for dashboard page
 *
 * @return {Object}
 */
export const chartRequested = payload => ({
  type: t.CHART_REQUESTED,
  payload,
});

/**
 * Report synthesis requested
 * dispatch this action to request a dashboard export
 *
 * @return {Object}
 */
export const reportSynthesisRequested = () => ({
  type: t.EXPORT_SYNTHESIS_REQUESTED,
});

/**
 * Sales report requested
 * dispatch this action to request a sales report export
 *
 * @return {Object}
 */
export const salesReportRequested = () => ({
  type: t.EXPORT_SALES_REQUESTED,
});

export { customersCountsAggregatedRequested } from './CustomersCountsAggregated/actions';
export { productTypesRequested } from './ProductTypes/actions';
export { revenuesAggregatedRequested } from './RevenuesAggregated/actions';
export { salesRequested } from './Sales/Global/actions';
